import styled from 'styled-components';

export const SearchSelectContainer = styled.div`
  width: ${({ width }) => `${width ? width : '100%'}`};
`;
